import { render, staticRenderFns } from "./ChangeOrg.vue?vue&type=template&id=53e0ac6c&"
import script from "./ChangeOrg.vue?vue&type=script&lang=js&"
export * from "./ChangeOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports